module.exports = __webpack_public_path__ + "img/img4.0655a5c6.jpg";